import { apiClient } from "../../api/services/api.service";

export const fetchDecisions = async (params?: any) =>
    await apiClient.get('/decisions/', { params });

export const fetchDecisionDetail = async (id: string) =>
    await apiClient.get(`/decisions/${id}/`);

export const createDecision = async (payload: any) =>
    await apiClient.post('/decisions/', payload);

export const updateDecision = async (id: string, payload: any) =>
    await apiClient.patch(`/decisions/${id}/`, payload);

export const deleteDecision = async (id: string) =>
    await apiClient.delete(`/decisions/${id}/`);

export const uploadDecisions = async (files: File[]) => {
    const formData = new FormData();
    files.forEach(file => formData.append('files', file));
    return await apiClient.post('/decisions/upload/', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        timeout: 120000,
    });
};

export const workflowAction = async (id: string, action: string) =>
    await apiClient.post(`/decisions/${id}/${action}/`);

// Pipeline polling — fetch historiques of a decision
export const fetchHistoriques = async (decisionId: string) =>
    await apiClient.get(`/decisions/${decisionId}/historiques/`);

// Dashboard stats: { par_statut, ce_mois, cette_semaine, par_juridiction, volume_mensuel }
export const fetchStats = async () =>
    await apiClient.get('/decisions/stats/');

// Export CSV (returns blob)
export const exportCSV = async (params?: any) =>
    await apiClient.get('/decisions/export/', {
        params,
        responseType: 'blob',
    });

// Admin dashboard
export const fetchAdminDashboard = async () =>
    await apiClient.get('/decisions/dashboard/');

// Admin pipeline supervision
export const fetchPipeline = async (params?: any) =>
    await apiClient.get('/decisions/pipeline/', { params });

// Admin reassign decisions
export const reassignDecisions = async (payload: any) =>
    await apiClient.post('/decisions/reassigner/', payload);

// Download original file as blob (proxied through backend to avoid S3 CORS)
export const fetchDecisionFichier = async (id: string) =>
    await apiClient.get(`/decisions/${id}/fichier/`, { responseType: 'blob' });

// Signal a problem on a decision
export const signalDecision = async (payload: { decision: string; commentaire: string; type_probleme?: string }) =>
    await apiClient.post('/decision-commentaire/', payload);

// Fetch signalements (commentaires) for a decision
export const fetchDecisionCommentaires = async (decisionId: string) =>
    await apiClient.get(`/decision-commentaire/${decisionId}/`);

// Super-admin dashboard endpoints
export const fetchSuperAdminDashboard = async () =>
    await apiClient.get('/decisions/superadmin/dashboard/');

export const fetchSuperAdminOrganisations = async () =>
    await apiClient.get('/decisions/superadmin/organisations/');

export const fetchSuperAdminStatistiques = async () =>
    await apiClient.get('/decisions/superadmin/statistiques/');
